import type { ScopeQuery } from "@app/shared"
import { z } from "zod"
import { http } from "../lib/http"
import { scopeQueryString } from "../scope/scope-query"

/**
 * Mirrors `DashboardStatsDto` on the engine. Flat counts the home
 * page renders as small stat cards.
 */
export const DashboardStatsSchema = z.object({
	activeShipments: z.number(),
	overdueDocuments: z.number(),
	pendingHeists: z.number(),
	unreadNotifications: z.number(),
	shipmentsDelta: z.number(),
	overdueOldestDays: z.number(),
	notificationsToday: z.number(),
})

export type DashboardStats = z.infer<typeof DashboardStatsSchema>

/** GET /dashboard/stats?country=&vertical= — scoped by the app-wide filter. */
export const getDashboardStats = async (
	scope?: ScopeQuery,
	signal?: AbortSignal,
): Promise<DashboardStats> => {
	const qs = scopeQueryString(scope)
	const raw = await http<unknown>(
		`/dashboard/stats${qs ? `?${qs}` : ""}`,
		signal !== undefined ? { signal } : {},
	)
	return DashboardStatsSchema.parse(raw)
}

export const dashboardQueryKeys = {
	all: ["dashboard"] as const,
	stats: (scope?: ScopeQuery) =>
		[
			...dashboardQueryKeys.all,
			"stats",
			scope?.country ?? "global",
			scope?.vertical ?? "all",
		] as const,
}
